// import _ from 'lodash';
import * as Actions from '../../actions/communication/types';

const initialState = {
  chats: [],
  getChatsLoading: false,
  error: '',
  deletedCustomer: null,
  totalUnread: '',
  selectedCustomerChat: '',
};

const communicationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Campaigns
    case Actions.GET_CUSTOMER_CHATS_REQUEST:
      return { ...state, getChatsLoading: true };

    case Actions.GET_CUSTOMER_CHATS_SUCCESS:
      // const chatsData = [...state?.chats];
      // const newChats = [...action?.payload];
      // const uniqueChats = _.uniqBy([...chatsData, ...newChats], 'id');
      return {
        ...state,
        getChatsLoading: false,
        chats: action?.payload || '',
      };

    case Actions.GET_CUSTOMER_CHATS_FAILURE:
      return {
        ...state,
        getChatsLoading: false,
        error: action.payload,
      };
    // ===================Send New Message==================
    case Actions.SEND_NEW_MESSAGE_REQUEST:
      return { ...state, newMsgloading: true };

    case Actions.SEND_NEW_MESSAGE_SUCCESS:
      return {
        ...state,
        newMsgloading: false,
        newMsgData: action.payload || '',
      };

    case Actions.SEND_NEW_MESSAGE_FAILURE:
      return {
        ...state,
        newMsgloading: false,
        error: action.payload,
      };
    // ===================Get Total Unread Messages Count==================
    case Actions.GET_UNREAD_COUNT_REQUEST:
      return { ...state, getCountLoading: true };

    case Actions.GET_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        getCountLoading: false,
        totalUnread: action.payload?.count || 0,
      };

    case Actions.GET_UNREAD_COUNT_FAILURE:
      return {
        ...state,
        getCountLoading: false,
        error: action.payload,
      };
    // ===================Update Chat Pinned==================

    case Actions.UPDATE_CUSTOMER_CHAT_PINNED:
      const customerChats = [...state.chats];
      const updatedResponse = action.payload;
      const chatIndx = customerChats.findIndex(
        (cCh) => cCh.id === updatedResponse.id,
      );

      if (chatIndx > -1) {
        customerChats[chatIndx].pinned = updatedResponse?.pinned;
      }
      return {
        ...state,
        chats: customerChats,
      };

    // ===================Delete Chat==================

    case Actions.DELETE_CHAT_REQUEST:
      return { ...state, deleteChatLoading: true };

    case Actions.DELETE_CHAT_SUCCESS:
      // const cusChats = [...state.chats];
      const customerId = action.payload?.id;

      // const chatIndex = cusChats.findIndex((cCh) => cCh.id === customerId);
      // if (chatIndex > -1) {
      //   cusChats.splice(chatIndex, 1);
      // }
      return {
        ...state,
        deleteChatLoading: false,
        deletedCustomer: customerId,
        // chats: cusChats,
      };
    case Actions.DELETE_CHAT_FAILURE:
      return {
        ...state,
        deleteChatLoading: false,
        error: action.payload,
      };
    // ===================Update Chat After Clear Conversion==================
    case Actions.UPDATE_CUSTOMER_CHAT_CLEAR_CONVERSION:
      const cusChatsD = [...state.chats];
      const cusId = action.payload;
      const chtIndx = cusChatsD.findIndex((cCh) => cCh.id === cusId);
      if (chtIndx > -1) {
        cusChatsD[chtIndx] = { ...cusChatsD[chtIndx], last_message: null };
      }
      return {
        ...state,
        chats: cusChatsD,
      };
    // ===================Update chat deleted key==================

    case Actions.UPDATE_CHAT_DELETED_KEY:
      return {
        ...state,
        deletedCustomer: null,
      };

    // ===================Minus unread count on select chat action(read msg api)==================

    case Actions.MINUS_UNREAD_COUNT:
      return {
        ...state,
        totalUnread: +state?.totalUnread - +action.payload || 0,
      };

    // ===================Plus unread count on New msg==================

    case Actions.PLUS_UNREAD_COUNT:
      let newCount = +state?.totalUnread;

      if (state.selectedCustomerChat !== action.payload?.customerId) {
        newCount += +action.payload?.count;
      }
      console.log('>>>>>>>>newCount', newCount, action.payload?.count);
      return {
        ...state,
        totalUnread: newCount || 0,
      };
    // ===================Selected Customer Chat (id to maintain unread msgs count) =============

    case Actions.SELECTED_CUSTOMER_CHAT:
      return {
        ...state,
        selectedCustomerChat: action.payload || '', // customer id
      };

    // ===================Clear New Msg==================

    case Actions.CLEAR_NEW_MESSAGE:
      return {
        ...state,
        newMsgData: '',
      };

    default:
      return state;
  }
};

export default communicationReducer;
